import { Grid } from '@mui/material'
import { FunctionComponent } from 'react'

import SimpleContainer from '../../../base/components/Container/SimpleContainer'
import AlmacenListado from './listado/AlmacenListado'

interface OwnProps {}

type Props = OwnProps

/**
 * Gestion o paginba principal para gestionar los almacen
 * @param props
 * @constructor
 */
const AlmacenGestion: FunctionComponent<Props> = (props) => {
  return (
    <SimpleContainer maxWidth={'lg'}>
      <Grid container spacing={2}>
        <Grid size={12}>
          <AlmacenListado />
        </Grid>
      </Grid>
    </SimpleContainer>
  )
}

export default AlmacenGestion
